import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export interface SearchFilterStartAdornmentClasses {
	/** styles applied to the root element */
	root: string;
}

export const getSearchFilterStartAdornmentClassesUtilityClass = (
	slot: string,
) => generateUtilityClass('SearchFilterStartAdornment', slot);

export const searchFilterStartAdornmentClasses = generateUtilityClasses(
	'SearchFilterStartAdornment',
	['root'],
);
export default searchFilterStartAdornmentClasses;
